import React from "react";
import NavbarSearch from "./../../Components/NavbarSearch/NavbarSearch";
import PATH from "../../constants/routes";
import { Link } from "react-router-dom";

export default function NavbarSearchWrapper() {
  return (
    <Link to={PATH.SEARCH} className="navbar_wrapper" style={{ width: "100%" }}>
      <NavbarSearch />
    </Link>
  );
}
